<template lang='pug'>
v-jumbotron(height='100%')
  v-container(fill-height grid-list-xl)
    v-layout(align-center)
      v-flex
        v-alert(
          :value='errors.has("common")'
          color='error'
          icon='warning'
          class='mb-3'
          outline
        ) {{ errors.first("common") }}
        h3(class="display-3") Сброс пароля по телефону
        span(class="subheading") Кто-то, возможны не вы бла-бла-бла
        div(class='mt-3 mb-2')
          v-text-field(
            large
            name='confirm_code'
            v-model='confirm_code'
            :error='errors.has("confirm_code")'
            :error-messages='errors.first("confirm_code")'
            label='Введите код, полученный по СМС'
            type='text'
          )
        div(class='mt-3 mb-2 d-flex')
            v-layout(wrap)
                v-flex(xs12 md6)
                    v-text-field(
                        large
                        name='new_pass'
                        v-model='new_pass'
                        :error='errors.has("new_pass")'
                        :error-messages='errors.first("new_pass")'
                        label='Введите пароль'
                        type='text'

                    )
                v-flex(xs12 md6)
                    v-text-field(
                        large
                        name='c_new_pass'
                        v-model='c_new_pass'
                        :error='errors.has("c_new_pass")'
                        :error-messages='errors.first("c_new_pass")'
                        label='Подтвердите пароль'
                        type='text'

                    )
        div
            v-layout(wrap bd-highlight mb-3)
                v-spacer
                v-btn(large flat @click='$router.push({ name: "Index" })')
                    v-icon(left) keyboard_backspace
                    span Вернуться на главную
                v-btn(large  color='primary' :loading='loading' @click='tryConfirm')
                    | Подтвердить
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    id: {
      type: String
    }
  },

  data: () => ({
    loading: false,
    confirm_code: '',
    new_pass: '',
    c_new_pass: ''
  }),

  methods: {
    tryConfirm() {
      this.loading = true

      this.resetConfirm({
        confirm_code: this.confirm_code,
        phone: this.id,
        new_pass: this.new_pass,
        c_new_pass: this.c_new_pass
      })
        .then(() => {
          this.$router.push({
            name: 'Index'
          })
        })
        .catch(error => {
          this.$setErrors(error.response)
        })
    },

    ...mapActions('auth', ['resetConfirm'])
  }
}
</script>
